import { render, staticRenderFns } from "./SalesNetwork.vue?vue&type=template&id=54c41cfc&scoped=true&"
import script from "./SalesNetwork.vue?vue&type=script&lang=js&"
export * from "./SalesNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c41cfc",
  null
  
)

export default component.exports